import client, { CLIENT_GET_FILE, CLIENT_POST_FILE } from 'api/client';

import { createPaginationValues, createURLParams } from 'utils/urls';

export const submitClaim = payload => CLIENT_POST_FILE.post('claims/submit/', payload);

export const deleteClaim = id => client.delete(`claims/${id}/`);

export const findAndUpdateClaim = (id, payload, params = {}) =>
  client.patch(`claims/${id}/`, payload, { params });

export const getClaimHistoryData = async claimId => {
  const { data } = await client.get(`claims/${claimId}/history/`);
  return data;
};

export const getClaims = ({ limit = 0, offset = 0, params = {}, sortBy = '' }) => {
  const queryParams = createURLParams({ limit, offset, ordering: sortBy, ...params });
  return client.get('claims/', { params: queryParams });
};

export const getClaimDetails = pk => client.get(`claims/${pk}/`);

export const getClaimDocument = (id, payload) =>
  CLIENT_GET_FILE.get(`claims/documents/${id}/`, payload);

export const uploadClaimDocument = payload => CLIENT_POST_FILE.post(`claims/documents/`, payload);

export const removeClaimDocument = id => client.delete(`claims/documents/${id}/`);

export const sendClaimContents = (id, payload) => client.patch(`claims/${id}/email/`, payload);

export const resendClaimRejectionEmail = (id, payload) =>
  client.patch(`claims/${id}/resend-claim-rejection-email/`, payload);

export const getPayments = async firmId => {
  const { data } = await client.get(`firms/${firmId}/payments/`);
  return data;
};

export const sendFeeReimbursementPayments = () =>
  client.post(`claims/send-fee-reimbursement-payments/`);

export const sendPaymentsForApprovedClaims = () =>
  client.post('claims/send-payments-for-approved-claims/');

export const sendPaymentEmails = () => client.post('claims/send-payment-emails/');

export const sendApprovedClaimsCsv = async payload => {
  const { data } = await client.post('claims/approved-claims-csv/', payload);
  return data;
};

export const sendApprovedFeeReimbursementsCsv = async () => {
  const { data } = await client.post('claims/approved-fee-reimbursements-csv/');
  return data;
};

export const getRecentClaimsByMember = id => client.get(`claims/${id}/recent/`);

export const getPaymentsForMailing = async () => {
  const { data } = await client.get('claims/get-payments-for-mailing/');
  return data;
};

export const getInNetworkApprovedUnpaidClaimsDetails = async () => {
  const { data } = await client.get('claims/get-in-network-approved-unpaid-claims-details/');
  return data;
};

export const emailFrClientStatements = async payload => {
  const { data } = await client.post('claims/send-client-statements/', payload);
  return data;
};

export const tipaltiEncryptQueryString = async baseQuery => {
  const queryParams = createURLParams({ query_string: baseQuery });
  const { data } = await client.get('claims/tipalti-encrypt-query-string/', {
    params: queryParams,
  });
  return data;
};

export const getAllOverpaymentRecoveries = async ({ pageSize, pageIndex, search }) => {
  const { limit, offset } = createPaginationValues({ pageSize, pageIndex });
  const queryParams = createURLParams({ limit, offset, ...search });
  const { data } = await client.get(`claims/recoveries/`, { params: queryParams });
  return data;
};

export const getOverpaymentRecoveries = async id => {
  const { data } = await client.get(`claims/${id}/recoveries/`);
  return data;
};

export const createOverpaymentRecovery = async payload => {
  const { data } = await client.post(`claims/recoveries/`, payload);
  return data;
};

export const updateOverpaymentRecovery = async payload => {
  const { data } = await client.patch(`claims/recoveries/${payload.id}/`, payload);
  return data;
};

export const deleteOverpaymentRecovery = async id => {
  const { data } = await client.delete(`claims/recoveries/${id}/`);
  return data;
};

export const getOverpaymentRecoveriesTotal = async filterParam => {
  const queryParams = createURLParams(filterParam);
  const { data } = await client.get(`claims/recoveries/total`, { params: queryParams });
  return data;
};

export const sendOverpaymentRecoveriesCSV = async filterParam => {
  const queryParams = createURLParams(filterParam);
  const { data } = await client.get(`claims/recoveries/csv`, { params: queryParams });
  return data;
};

export const uploadOverpaymentRecoveriesCSV = async payload => {
  const { data } = await CLIENT_POST_FILE.post(`claims/recoveries/upload/`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const getPayPeriods = async () => {
  const { data } = await client.get('claims/get-last-six-months-pay-periods/');
  return data;
};

export const deletePayPeriod = async id => {
  const { data } = await client.delete(`claims/payment-periods/${id}/`);
  return data;
};

export const getMLPClaimAudit = async ({ pageSize, pageIndex, ...otherParams }) => {
  const { limit, offset } = createPaginationValues({ pageSize, pageIndex });
  const queryParams = createURLParams({ limit, offset, ...otherParams });
  const { data } = await client.get('claims/mlp-audit/', { params: queryParams });
  return data;
};

export const sendMLPAuditCsv = async params => {
  const queryParams = createURLParams(params);
  const { data } = await client.get(`claims/mlp-audit/csv_task/`, { params: queryParams });
  return data;
};
